import React from 'react';
import { SmartLink } from 'components/smart-link';
import Teeth from 'assets/icons/teeth.svg';
import ThumbDown from 'assets/icons/thumbDown.svg';
import ThumbUp from 'assets/icons/thumbUp.svg';
import ReactDOMServer from 'react-dom/server';
import * as styles from './product-pros-cons.module.scss';
import { ProductType } from '../type';

type ProductProsConsProps = {
  product: ProductType
};

const ProductProsCons = (props: ProductProsConsProps) => {
  const { product } = props;

  return (
    <div className={styles.prosConsContainer}>
      <div className={styles.cardTitle}>{product.name}</div>
      <div className={styles.prosConsDetails}>
        <img src={product.image.url} className={styles.productImg} alt={product.name} />
        <div className={styles.description}>{product.description}</div>
        <div className={styles.prosConsLists}>
          <div>
            <div className={styles.pros}>
              <ThumbUp />
              PROS
            </div>
            {product?.pros?.map((p) => (
              <div key={p.id} className={styles.item}>
                <Teeth />
                {p.item}
              </div>
            ))}
          </div>
          <div className={styles.divider} />
          <div>
            <div className={styles.cons}>
              <ThumbDown />
              CONS
            </div>
            {product.cons?.map((c) => (
              <div key={c.id} className={styles.item}>
                <Teeth />
                {c.item}
              </div>
            ))}
          </div>
        </div>
        <SmartLink
          to={product.site.link}
          className={styles.priceButton}
        >
          {`$${product.price} BUY`}
        </SmartLink>
      </div>
    </div>
  );
};

function parseProductProsCons(
  content: string,
  productList: ProductType[],
): string {
  let modifiedContent = content;
  let start = modifiedContent.indexOf('<productproscons>') + '<productproscons>'.length;
  let end = modifiedContent.indexOf('</productproscons>', start);
  let parsing = start > -1 && end > -1;

  while (parsing) {
    const id = modifiedContent.substring(start, end);
    const product = productList.find((p) => p.strapi_id.toString() === id);

    if (product) {
      const productProsCons = <ProductProsCons product={product} />;
      modifiedContent = modifiedContent.replace(modifiedContent.substring(start, end + '</productproscons>'.length), ReactDOMServer.renderToStaticMarkup(productProsCons));
    } else {
      modifiedContent = modifiedContent.replace(modifiedContent.substring(start, end + '</productproscons>'.length), '');
    }

    start = modifiedContent.indexOf('<productproscons>', end) + '<productproscons>'.length;
    end = modifiedContent.indexOf('</productproscons>', start);
    parsing = start > -1 && end > -1;
  }

  return modifiedContent;
}

export { ProductProsCons, parseProductProsCons };
